/* tslint:disable */
/* eslint-disable */
/**
 * Agent service API
 * Service for credentials management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PublicDetailsResponseDto,
} from '../models/index';
import {
    PublicDetailsResponseDtoFromJSON,
    PublicDetailsResponseDtoToJSON,
} from '../models/index';

export interface GetDossierCesrDetailsRequest {
    said: string;
}

/**
 * 
 */
export class PublicControllerApi extends runtime.BaseAPI {

    /**
     * Url for this endpoint is set in passports
     * Get Dossier cesr
     */
    async getDossierCesrDetailsRaw(requestParameters: GetDossierCesrDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PublicDetailsResponseDto>> {
        if (requestParameters['said'] == null) {
            throw new runtime.RequiredError(
                'said',
                'Required parameter "said" was null or undefined when calling getDossierCesrDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/agent/public/{said}/dossier.cesr`.replace(`{${"said"}}`, encodeURIComponent(String(requestParameters['said']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PublicDetailsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Url for this endpoint is set in passports
     * Get Dossier cesr
     */
    async getDossierCesrDetails(requestParameters: GetDossierCesrDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PublicDetailsResponseDto | null | undefined > {
        const response = await this.getDossierCesrDetailsRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

}
